module.exports = __webpack_public_path__ + "img/provision-device-fill.d846e300.svg";